<template>
  <div class="my-10">
    <div class="flex justify-between mb-5">
      <h1 class="text-2xl font-bold">
        {{ $t('nav.restaurants') }}
      </h1>
      <button
        @click="toggleFilter(true)"
        class="hidden gap-2 items-center text-main-color bg-white p-2 rounded-lg max-lg:flex"
      >
        <IconFilter />
        <p>{{ $t('page.filter') }}</p>
      </button>
    </div>
    <div class="grid grid-cols-4 gap-5">
      <div class="col-span-1">
        <FoodSide
          routeName="foodRestaurants"
          @closeFilter="toggleFilter(false)"
          :filterState="filterState"
          :currentCategory="query.categories"
          :currentSubscription="query.subscription"
          :isVip="query.is_vip"
          :currentIsNew="query.is_new"
          :currentIsPromotion="query.in_promotion"
          :currentHasDiscount="query.has_discount"
          :location="getLocation.id"
          :hideFilters="['currentPrice', 'currentCategory']"
        ></FoodSide>
      </div>
      <div class="col-span-3 max-md:col-span-4">
        <div class="grid grid-cols-3 gap-4 max-lg:grid-cols-2">
          <template v-if="restaurants.length > 0">
            <router-link
              v-for="item in restaurants"
              :key="item?.id"
              :to="{ name: 'foodRestaurantDetail', params: { id: item?.id } }"
            >
              <StoreCard :detail="item"> </StoreCard>
            </router-link>
          </template>
          <div v-show="restaurants.length === 0 && loading === false">
            <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.not_found') }}</p>
          </div>
        </div>
        <div v-show="loading === true" class="flex justify-center mt-10" role="status">
          <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin fill-main-color">
          </IconSpinner>

          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconSpinner from '@icons/IconSpinner.vue';
import IconFilter from '@icons/IconFilter.vue';
import StoreCard from '@cmp/mall/StoreCard.vue';
import FoodSide from '@cmp/food/FoodSide.vue';
import api from '@/api';
import { updateLastSeen } from '@/helpers';

export default {
  name: 'foodRestaurants',
  components: {
    StoreCard,
    FoodSide,
    IconSpinner,
    IconFilter,
  },
  watch: {
    '$route.query': {
      async handler() {
        this.syncQueryFromRoute();
        await this.resetAndLoadRestaurants();
      },
    },
  },
  data() {
    return {
      loading: false,
      restaurants: [],
      count: 0,
      next: null,
      query: {
        categories: undefined,
        subscription: undefined,
        is_vip: undefined,
        is_new: undefined,
        in_promotion: undefined,
        has_discount: undefined,
        location: undefined,
        page: 1,
      },
      filterState: false,
    };
  },
  methods: {
    toggleFilter(e) {
      this.filterState = e;
      document.body.style.overflowY = e ? 'hidden' : 'initial';
    },

    syncQueryFromRoute() {
      this.query.categories = this.$route.query.category;
      this.query.subscription = this.$route.query.subscription;
      this.query.is_vip = this.$route.query.is_vip;
      this.query.is_new = this.$route.query.is_new;
      this.query.in_promotion = this.$route.query.in_promotion;
      this.query.has_discount = this.$route.query.has_discount;
      this.query.location = this.getLocation.id;
    },

    async resetAndLoadRestaurants() {
      this.query.page = 1;
      this.restaurants = [];
      this.count = 0;
      this.next = null;
      await this.getRestaurants();
    },

    infiniteScroll() {
      let scrollTop = document.documentElement.scrollTop;
      let scrollHeight = document.documentElement.scrollHeight;
      let clientHeight = document.documentElement.clientHeight;

      if (scrollTop + clientHeight >= scrollHeight - 650) {
        if (this.next !== null && this.loading === false) {
          this.query.page += 1;
          this.getRestaurants();
        }
      }
    },

    async getRestaurants() {
      this.loading = true;
      try {
        const response = await api.get('exhibition/stores/', { params: this.query });
        const results = response.data.results || [];

        if (this.query.page === 1) {
          this.restaurants = results;
        } else {
          this.restaurants.push(...results);
        }

        this.count = response.data.count;
        this.next = response.data.next;
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
  },
  computed: {
    getLocation() {
      return JSON.parse(localStorage.getItem('selectedLocation')) || 1;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.infiniteScroll);
  },
  unmounted() {
    window.removeEventListener('scroll', this.infiniteScroll);
  },
  async created() {
    this.syncQueryFromRoute();
    await this.getRestaurants();
    updateLastSeen('exhibition_stores');
  },
};
</script>

<style scoped></style>
